
export default function StorySection() {
  return (
    <section id="story" className="py-20 bg-gradient-to-b from-white to-amber-50">
      <div className="max-w-6xl mx-auto px-6">
        <div 
          className="text-center mb-16 py-20 rounded-2xl bg-cover bg-center bg-no-repeat relative overflow-hidden"
          style={{
            backgroundImage: `linear-gradient(rgba(255, 255, 255, 0.85), rgba(255, 255, 255, 0.85)), url('https://static.readdy.ai/image/959e648e6129dfa107ce7f6338adad12/57086a85c9f5012db3020c0a28c274f2.jpeg')`
          }}
        >
          {/* 裝飾性背景元素 */}
          <div className="absolute inset-0 bg-gradient-to-r from-amber-100/30 via-transparent to-orange-100/30"></div>
          <div className="absolute top-4 left-4 w-20 h-20 bg-amber-200/20 rounded-full blur-xl"></div>
          <div className="absolute bottom-4 right-4 w-32 h-32 bg-orange-200/20 rounded-full blur-xl"></div>
          
          <div className="relative z-10">
            <h2 className="text-5xl md:text-6xl lg:text-7xl font-bold text-gray-800 mb-8 leading-tight">
              <span className="block text-amber-700 font-['Pacifico'] text-4xl md:text-5xl lg:text-6xl mb-4">
                馬的咖啡
              </span>
              <span className="block text-gray-800">故事館</span>
            </h2>
            
            {/* 主要標語 - 透明背景設計 */}
            <div className="relative mx-auto max-w-5xl mb-8">
              {/* 透明背景層 */}
              <div className="absolute inset-0 bg-white/10 backdrop-blur-sm rounded-2xl"></div>
              
              {/* 內容區域 */}
              <div className="relative z-10 px-8 py-6 rounded-2xl border border-white/20">
                <p className="text-2xl md:text-3xl lg:text-4xl font-bold leading-relaxed text-gray-800">
                  <span className="block mb-3">
                    🏔️ 來自卓社林道的高山之味
                  </span>
                  <span className="block text-xl md:text-2xl lg:text-3xl">
                    <span className="inline-block bg-amber-600/80 text-white px-4 py-2 rounded-full font-black mr-3 shadow-lg backdrop-blur-sm">
                      連續三年
                    </span>
                    <span className="text-gray-800">榮獲</span>
                    <span className="inline-block bg-amber-500/80 text-white px-4 py-2 rounded-full font-black mx-2 shadow-lg backdrop-blur-sm">
                      南投評鑑咖啡
                    </span>
                  </span>
                  <span className="block mt-3 text-xl md:text-2xl lg:text-3xl">
                    <span className="inline-block bg-red-500/80 text-white px-4 py-2 rounded-full font-black mr-2 shadow-lg backdrop-blur-sm">
                      🏆 特等獎
                    </span>
                    <span className="text-gray-800">｜</span>
                    <span className="inline-block bg-orange-500/80 text-white px-4 py-2 rounded-full font-black ml-2 shadow-lg backdrop-blur-sm">
                      🥇 頭等獎
                    </span>
                    <span className="block mt-2 text-gray-800 font-semibold">得主</span>
                  </span>
                </p>
              </div>
            </div>

            {/* 副標語 - 透明背景設計 */}
            <div className="relative mx-auto max-w-4xl">
              {/* 透明背景層 */}
              <div className="absolute inset-0 bg-white/10 backdrop-blur-sm rounded-2xl"></div>
              
              {/* 內容區域 */}
              <div className="relative z-10 px-8 py-6 rounded-2xl border border-white/20">
                <div className="flex flex-wrap items-center justify-center gap-6 text-lg md:text-xl">
                  <div className="flex items-center space-x-3 bg-white/20 backdrop-blur-sm px-6 py-3 rounded-full border border-white/30 transform hover:scale-105 transition-all duration-300">
                    <div className="w-8 h-8 bg-gradient-to-br from-emerald-500 to-green-600 rounded-full flex items-center justify-center shadow-inner">
                      <i className="ri-mountain-line text-white text-lg"></i>
                    </div>
                    <span className="font-bold text-gray-800 tracking-wide">海拔 1200 公尺</span>
                  </div>
                  
                  <span className="text-amber-600 font-light text-2xl">×</span>
                  
                  <div className="flex items-center space-x-3 bg-white/20 backdrop-blur-sm px-6 py-3 rounded-full border border-white/30 transform hover:scale-105 transition-all duration-300">
                    <div className="w-8 h-8 bg-gradient-to-br from-blue-500 to-cyan-600 rounded-full flex items-center justify-center shadow-inner">
                      <i className="ri-shield-check-line text-white text-lg"></i>
                    </div>
                    <span className="font-bold text-gray-800 tracking-wide">無毒栽培</span>
                  </div>
                  
                  <span className="text-amber-600 font-light text-2xl">×</span>
                  
                  <div className="flex items-center space-x-3 bg-white/20 backdrop-blur-sm px-6 py-3 rounded-full border border-white/30 transform hover:scale-105 transition-all duration-300">
                    <div className="w-8 h-8 bg-gradient-to-br from-purple-500 to-violet-600 rounded-full flex items-center justify-center shadow-inner">
                      <i className="ri-hand-heart-line text-white text-lg"></i>
                    </div>
                    <span className="font-bold text-gray-800 tracking-wide">手工精選</span>
                  </div>
                  
                  <span className="text-amber-600 font-light text-2xl">×</span>
                  
                  <div className="flex items-center space-x-3 bg-white/20 backdrop-blur-sm px-6 py-3 rounded-full border border-white/30 transform hover:scale-105 transition-all duration-300">
                    <div className="w-8 h-8 bg-gradient-to-br from-amber-500 to-yellow-600 rounded-full flex items-center justify-center shadow-inner">
                      <i className="ri-fire-line text-white text-lg"></i>
                    </div>
                    <span className="font-bold text-gray-800 tracking-wide">小量烘焙</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 mb-16">
          <div className="bg-white rounded-2xl p-8 shadow-lg">
            <div className="flex items-center mb-6">
              <div className="w-12 h-12 bg-amber-100 rounded-full flex items-center justify-center mr-4">
                <i className="ri-calendar-line text-xl text-amber-600"></i>
              </div>
              <div>
                <h3 className="text-2xl font-bold text-gray-800">June, 2018</h3>
                <p className="text-gray-600">故事的開始</p>
              </div>
            </div>
            <div className="space-y-4 text-gray-700 leading-relaxed">
              <p>
                那是2018年的夏天，63歲的馬爸爸和馬媽媽站在卓社林道的原始林中，望著眼前雜草叢生的土地，心中懷著一個看似不可能的夢想——在這片與世隔絕的山林裡，種出屬於自己的咖啡。
              </p>
              <p>
                沒有人相信兩個花甲之年的老人家能在這荒蕪之地創造奇蹟。但馬爸爸和馬媽媽用雙手，一草一木地整理著這片土地，每一寸土壤都浸透了他們的汗水與堅持。八個月的時光，從日出到日落，從春雨到秋霜，他們用最原始的方式，為咖啡樹打造一個溫暖的家。
              </p>
              <p>
                從完全沒有經驗到慢慢摸索，每一次的失敗都像是重重的打擊，但也是珍貴的學習。馬爸爸常說：「做人要有傻勁，做事要有真心。」就是這份傻勁和真心，讓他們把咖啡樹當作自己的孩子般細心呵護，每一顆果實都承載著滿滿的愛意。
              </p>
              <p>
                在這片與野生動物共存的土地上，馬爸爸養了一群忠實的狗兒夥伴，守護著珍貴的咖啡果實。為了照顧這些「綠色孩子」，馬爸爸甚至選擇在山上過夜，在沒有電力的寂靜夜晚中，只有星光和蟲鳴作伴。這樣的生活對許多人來說或許艱苦，但對馬爸爸來說，這就是與大自然最真摯的對話。
              </p>
              <p className="font-semibold text-amber-700 text-lg">
                七年來，馬爸爸和馬媽媽用生命書寫著這個咖啡故事。與山為家的滋味，就是咖啡最自然的味道。每一杯「馬的咖啡」，都想讓您感受到這份來自高山深處最溫暖、最樸實的愛與堅持。
              </p>
            </div>
          </div>

          <div className="space-y-6">
            <div className="bg-white rounded-2xl p-8 shadow-lg">
              <h3 className="text-2xl font-bold text-gray-800 mb-6">高山環境</h3>
              <div className="space-y-4 text-gray-700">
                <div className="flex items-start space-x-3">
                  <i className="ri-mountain-line text-xl text-green-600 mt-1"></i>
                  <div>
                    <p className="font-semibold">海拔 1200-1300 公尺</p>
                    <p className="text-sm">卓社林道高山環境</p>
                  </div>
                </div>
                <div className="flex items-start space-x-3">
                  <i className="ri-drop-line text-xl text-blue-600 mt-1"></i>
                  <div>
                    <p className="font-semibold">高山泉水灌溉</p>
                    <p className="text-sm">從石頭縫隙流出的純淨水質</p>
                  </div>
                </div>
                <div className="flex items-start space-x-3">
                  <i className="ri-temp-cold-line text-xl text-purple-600 mt-1"></i>
                  <div>
                    <p className="font-semibold">溫度 12-26°C</p>
                    <p className="text-sm">常年雲霧繚繞，日夜溫差大</p>
                  </div>
                </div>
                <div className="flex items-start space-x-3">
                  <i className="ri-shield-check-line text-xl text-emerald-600 mt-1"></i>
                  <div>
                    <p className="font-semibold">無毒田間管理</p>
                    <p className="text-sm">380項農藥檢測未檢出</p>
                  </div>
                </div>
              </div>
            </div>

            <div className="bg-gradient-to-r from-amber-100 to-orange-100 rounded-2xl p-8">
              <h3 className="text-2xl font-bold text-gray-800 mb-4">馬的咖啡堅持</h3>
              <ul className="space-y-3 text-gray-700">
                <li className="flex items-center space-x-3">
                  <i className="ri-check-line text-amber-600"></i>
                  <span>在地產區直送，無混豆、無調味</span>
                </li>
                <li className="flex items-center space-x-3">
                  <i className="ri-check-line text-amber-600"></i>
                  <span>每批手工挑豆，接單小量烘焙</span>
                </li>
                <li className="flex items-center space-x-3">
                  <i className="ri-check-line text-amber-600"></i>
                  <span>認真做豆、用心說話，不浮誇、不妥協</span>
                </li>
              </ul>
            </div>
          </div>
        </div>

        {/* 獲獎記錄 */}
        <div className="bg-white rounded-2xl p-8 shadow-lg mb-16">
          <div className="text-center mb-8">
            <h3 className="text-3xl font-bold text-gray-800 mb-4">獲獎記錄</h3>
            <p className="text-gray-600">連續三年南投縣咖啡評鑑得獎</p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            <div className="text-center p-6 bg-gradient-to-b from-yellow-50 to-yellow-100 rounded-xl">
              <div className="w-16 h-16 bg-yellow-400 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-trophy-line text-2xl text-white"></i>
              </div>
              <h4 className="font-bold text-gray-800 mb-2">112年</h4>
              <p className="text-sm text-gray-600">優等獎</p>
            </div>
            
            <div className="text-center p-6 bg-gradient-to-b from-amber-50 to-amber-100 rounded-xl">
              <div className="w-16 h-16 bg-amber-500 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-medal-line text-2xl text-white"></i>
              </div>
              <h4 className="font-bold text-gray-800 mb-2">113年</h4>
              <p className="text-sm text-gray-600">特等獎 & 頭等獎</p>
            </div>
            
            <div className="text-center p-6 bg-gradient-to-b from-orange-50 to-orange-100 rounded-xl">
              <div className="w-16 h-16 bg-orange-500 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-award-line text-2xl text-white"></i>
              </div>
              <h4 className="font-bold text-gray-800 mb-2">114年</h4>
              <p className="text-sm text-gray-600">金質獎 & 頭等獎</p>
            </div>
          </div>
        </div>

        {/* 2025年杯測報告 */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 mb-16">
          <div className="bg-white rounded-2xl p-8 shadow-lg border-l-4 border-yellow-400">
            <div className="flex items-center mb-6">
              <div className="w-12 h-12 bg-yellow-100 rounded-full flex items-center justify-center mr-4">
                <i className="ri-award-fill text-xl text-yellow-600"></i>
              </div>
              <div>
                <h4 className="text-xl font-bold text-gray-800">2025 金質獎</h4>
                <p className="text-gray-600">水洗組 | 總分 85.19</p>
              </div>
            </div>
            <div className="space-y-4">
              <div>
                <h5 className="font-semibold text-gray-800 mb-2">品種與處理</h5>
                <p className="text-sm text-gray-600">SL34 | 水洗處理</p>
              </div>
              <div>
                <h5 className="font-semibold text-gray-800 mb-2">風味描述</h5>
                <p className="text-sm text-gray-600">
                  莓果、柑橘、紅糖、酸甜平衡、黑莓、黃糖、杏桃果花、青蘋果、巧克力、風味明確、厚實飽滿
                </p>
              </div>
              <div>
                <h5 className="font-semibold text-gray-800 mb-2">酸質評價</h5>
                <p className="text-sm text-gray-600">中高等、明亮有層次、桃子轉莓果活潑酸值</p>
              </div>
            </div>
          </div>

          <div className="bg-white rounded-2xl p-8 shadow-lg border-l-4 border-amber-400">
            <div className="flex items-center mb-6">
              <div className="w-12 h-12 bg-amber-100 rounded-full flex items-center justify-center mr-4">
                <i className="ri-medal-fill text-xl text-amber-600"></i>
              </div>
              <div>
                <h4 className="text-xl font-bold text-gray-800">2025 頭等獎</h4>
                <p className="text-gray-600">其他處理組 | 總分 84.38</p>
              </div>
            </div>
            <div className="space-y-4">
              <div>
                <h5 className="font-semibold text-gray-800 mb-2">品種與處理</h5>
                <p className="text-sm text-gray-600">SL34 | 蜜處理</p>
              </div>
              <div>
                <h5 className="font-semibold text-gray-800 mb-2">風味描述</h5>
                <p className="text-sm text-gray-600">
                  莓果、李子、熱帶水果、醋栗、葡萄乾、龍眼乾、杏桃乾、風味明確、酸甜平衡
                </p>
              </div>
              <div>
                <h5 className="font-semibold text-gray-800 mb-2">酸質評價</h5>
                <p className="text-sm text-gray-600">中等、活潑明亮、果汁感、明亮的醋栗及李子、葡萄乾、柔順</p>
              </div>
            </div>
          </div>
        </div>

        {/* 風味描述 */}
        <div className="bg-gradient-to-r from-amber-600 to-orange-600 rounded-2xl p-8 text-white text-center">
          <h3 className="text-3xl font-bold mb-6">風味筆記</h3>
          <p className="text-2xl md:text-3xl leading-relaxed font-medium">
            一杯討喜、一杯溫暖、一杯耐人尋味、一杯真正會留在心裡的咖啡。
          </p>
        </div>
      </div>
    </section>
  );
}
